/**
 * Welcome — Public marketing landing page.
 * Route: /welcome (unauthenticated, accessible sans login).
 * Toutes les sections orchestrées ici. Composants dans components/welcome/.
 */
import { useEffect } from "react";
import WelcomeHeader from "@/components/welcome/WelcomeHeader";
import Hero from "@/components/welcome/Hero";
import PersonaSelector from "@/components/welcome/PersonaSelector";
import ModulesGrid from "@/components/welcome/ModulesGrid";
import ProductTour from "@/components/welcome/ProductTour";
import Testimonials from "@/components/welcome/Testimonials";
import Pricing from "@/components/welcome/Pricing";
import FAQSection from "@/components/welcome/FAQSection";
import CTAFinal from "@/components/welcome/CTAFinal";
import WelcomeFooter from "@/components/welcome/WelcomeFooter";
import { APP_NAME, APP_TAGLINE } from "@/lib/branding";

export default function Welcome() {
  useEffect(() => {
    document.title = `${APP_NAME} — ${APP_TAGLINE}`;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen bg-[#F8FAFC] text-[#0B0F17] antialiased"
      style={{ fontFamily: "'Plus Jakarta Sans', 'Manrope', system-ui, sans-serif" }}
      data-testid="welcome-page"
    >
      <WelcomeHeader />
      <main>
        <Hero />
        <PersonaSelector />
        <ModulesGrid />
        <ProductTour />
        <Testimonials />
        <Pricing />
        <FAQSection />
        <CTAFinal />
      </main>
      <WelcomeFooter />
    </div>
  );
}
